import FronendWebDevplor from "../skillsMain/FronendWebDevplor.webp";
import crossPlatform from "../skillsMain/crossPlatform.webp";

export const skillMain = [
  {
    img: FronendWebDevplor,
    title: "Front End Developer",
    subtitle:
      "Having Experience with Front End Liberaries and frameworks, Exposure to REST APIs and Single State web apps",
  },
  {
    img: crossPlatform,
    title: "Aspiring Cross Platform React Native Developer",
    subtitle:
      "Has Built basic Native Android Apps , Familiarity with Statefull apps and Hardware access",
  },
];
